import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PostRequestCached } from "../generics/helper";

const VehicleAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], disabled = false, isFormikFormField = false, showFormError = false, editMode = false,
        isCompulsory = false, singleSelect = true, label = "Vehicle No", searchPlaceholder = "Search By Vehicle No",
        noDataLabel = "No Vehicle No Found", width = "100%", listWidth = width, forOem, forModel, onlyLoginBranchAppVehicles = 'N',
        ...rest } = props;
    let vehicleOptions = [];
    /* const getVehicleOptions = async (vehicleNo) => {
        const getVehicleParams = {vehicleNo};
        const response = await fetchApi('masters/getVehicles',getVehicleParams,userToken);
        console.log(response);
        if(response.status === 'Ok' && response.data.responseStatus === 'Ok'){
            let newOptions = [];
            if(response.data.vehicles.length > 0){
                newOptions = newOptions.concat(response.data.vehicles);
            }
            console.log(newOptions);
            return newOptions
        }
    } */
    let initialProps = {
        ...rest,
        labelKey: 'vehicleNo',
        primaryKey: 'vehicleId',
        options: vehicleOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        // remoteData:true,
        // fetchRemoteDataHandler:getVehicleOptions,
        dataLoaded: false,
        disabled,
        editMode,
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getVehicleOptions = async () => {
            let getVehicleParams = {};
            if (forOem && forOem !== '') {
                getVehicleParams = { ...getVehicleParams, getFullDetails: 'Y', searchVehicleOemIds: forOem }
            }
            if (forModel && forModel !== '') {
                getVehicleParams = { ...getVehicleParams, searchVehicleModelIds: forModel }
            }
            if(onlyLoginBranchAppVehicles && onlyLoginBranchAppVehicles === 'Y'){
                getVehicleParams = { ...getVehicleParams, onlyLoginBranchAppVehicles }
            }
            // const response = await fetchApi('masters/getVehicles', getVehicleParams, userToken);
            const response = await PostRequestCached('masters/getVehicles', getVehicleParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption)
                    newOptions.push({ vehicleNo: 'All Vehicles', vehicleId: '', vehicleCode: '' });
                if (response.data.vehicles.length > 0) {
                    newOptions = newOptions.concat(response.data.vehicles).map((item) => item?.vehicleCode !== "" ? { ...item, vehicleNo: `${item?.vehicleNo} (${item?.vehicleCode})` } : item);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((v) => selectedValues.indexOf(v.vehicleId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getVehicleOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forOem, forModel, onlyLoginBranchAppVehicles]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((v) => selectedValues.indexOf(v.vehicleId) >= 0);
        }

        setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: !editMode });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
})

export default VehicleAutocomplete;